module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAUCAYAAACJfM0wAAAAp0lEQVQ4jb2VUQ4DIQhEp01v4E3k9txBTwLhCPTLpm3Whd2t5cvo8EwQRpiZM7OLiF8NEXFmdjNzvG9cgX8zMDu4Av0An4XPcpAVHoFugrPwSLMJjhIzF0/BM4Cqpkp1c3fHTqgqeu+otQLAa11K2UtDCB7w1hoAgIhCKADcQ8XJeESCUQoiApAvxeHHy/b5f9ttyYAsGeklJrTENpcY/S+/puEjZuZPpm5y2XaXD54AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y73.png
// module id = aaZ2
// module chunks = 1